import { render, staticRenderFns } from "./EmployerCompany.vue?vue&type=template&id=2a26ddd4&scoped=true&"
import script from "./EmployerCompany.vue?vue&type=script&lang=js&"
export * from "./EmployerCompany.vue?vue&type=script&lang=js&"
import style0 from "./EmployerCompany.vue?vue&type=style&index=0&id=2a26ddd4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a26ddd4",
  null
  
)

export default component.exports